import {DetailsField} from '@/components/ui/details-atoms/DetailsAtoms'
import {useTranslation} from '@/translations/i18n'
import {Button} from '@/components/ui/button/Button'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {ChevronLeftIcon, ChevronRightIcon} from '@/components/ui/icon/Icon'
import {Text} from '@/components/ui/text/Text'
import {teamGroupToLabel} from '@/features/treatment-requests/teams/utils'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import React, {useState} from 'react'

import {ProjectExtended} from '../../types'
import {EmptyState} from '@/components/commons/empty-state/EmptyState'

export interface ReserveTeamBodyProps {
    team: ProjectExtended['team']
}

export const ReserveTeamBody: React.FC<ReserveTeamBodyProps> = ({team}) => {
    const {t} = useTranslation()
    const [page, setPage] = useState(1)

    const filteredTeam = team.filter(member => member.isAReserve)
    // Rule: Modularization
    // Group team members into chunks of 4 for pagination
    const ITEMS_PER_PAGE = 4
    const paginatedTeam = filteredTeam.slice((page - 1) * ITEMS_PER_PAGE, page * ITEMS_PER_PAGE)
    const totalPages = Math.ceil(filteredTeam.length / ITEMS_PER_PAGE)

    const handleNextPage = () => {
        totalPages > page && setPage(page + 1)
    }

    const handlePreviousPage = () => {
        page > 1 && setPage(page - 1)
    }

    if (paginatedTeam.length === 0) {
        return <EmptyState variant="secondary" title={t('projects:no_reserve_team_members')} />
    }
    return (
        <Flexbox direction="column" gap={4} fullWidth style={{height: '100%', justifyContent: 'space-between'}}>
            <Grid columns={2} gap={3} fullWidth>
                {paginatedTeam.map(teamMember => (
                    <DetailsField fullWidth key={teamMember.id}>
                        <Flexbox gap={1}>
                            <Text palette="neutral" shade="600" size="textSm">
                                {t(teamGroupToLabel[teamMember.group])}
                            </Text>
                            <Text palette="neutral" shade="500" size="textSm">
                                {teamMember.specializationName}
                            </Text>
                        </Flexbox>
                        <Text palette="neutral" shade="950" size="textSm" weight="500">
                            {teamMember.fullName}
                        </Text>
                    </DetailsField>
                ))}
            </Grid>
            <Flexbox gap={2} justify="end" fullWidth>
                <Button variant="ghost" size="sm" shape="square" onClick={handlePreviousPage} disabled={page == 1}>
                    <ChevronLeftIcon />
                </Button>
                <Button variant="ghost" size="sm" shape="square" onClick={handleNextPage} disabled={totalPages == page}>
                    <ChevronRightIcon />
                </Button>
            </Flexbox>
        </Flexbox>
    )
}
